import React from 'react';
import { useNavigate } from 'react-router-dom';


export default function HRCopilotOnboarding() {
    const navigate = useNavigate();

    const handleAccessRecruit = () => navigate('/onboarding');

    const styles = `
    .hrco-container {
      min-height: 100vh;
      background: linear-gradient(135deg, #ffffffff 0%, #ffffffff 100%);
      padding: 60px 40px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      margin-top: 60px;
    }

    .hrco-content-wrapper {
      max-width: 1400px;
      margin: 0 auto;
      position: relative;
    }

    /* Top Heading */
    .hrco-heading-top {
      margin-bottom: 20px;
    }

    .hrco-badge {
      display: inline-block;
      background-color: #d4e3fc;
      color: #1a73e8;
      padding: 8px 20px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .hrco-main-heading {
      font-size: 44px;
      font-weight: 700;
      line-height: 1.1;
                font-style: italic;
                          color: #1a1a1a;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;


//       background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   background-clip: text;
      margin: 0;
      margin-left: -540px;
    }

    /* Explore Button Bottom Right */
    .hrco-explore-btn {
      position: absolute;
      right: 0;
      bottom: -40px;
      background-color: transparent;
  color: #165ef0;
      padding: 14px 32px;
      border-radius: 10px;
      font-size: 16px;
  border: 2px solid #165ef0;
      cursor: pointer;
      box-shadow: 0 10px 25px rgba(0,0,0,0.15);
      transition: 0.3s ease;
   
    }

    .hrco-explore-btn:hover {
  background: #165ef01a;
    }

    /* Image Section */
    .hrco-image-section {
      margin-top: 100px;
      display: flex;
      justify-content: center;
      position: relative;
    }

    .image-wrapper {
      position: relative;
      width: fit-content;
    }

    .image-main {
      width: 950px;
      border-radius: 16px;
    //   box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    margin-right: 40px;
    }

    .image-overlap {
      position: absolute;
      top: -200px; 
      right: -250px; 
      width: 620px;
      border-radius: 12px;
    //   box-shadow: 0 10px 25px rgba(0,0,0,0.12);
    }

    /* Responsive */
    @media (max-width: 768px) {
      .hrco-main-heading {
        font-size: 38px;
      }
      .hrco-explore-btn {
        position: relative;
        margin-top: 20px;
        bottom: 0;
        right: 0;
      }
      .image-main {
        width: 100%;
      }
      .image-overlap {
        width: 60%;
        right: -20px;
        top: -20px;
      }
    }
  `;

    return (
        <>
            <style>{styles}</style>

            <div className="hrco-container">
                <div className="hrco-content-wrapper">

                    {/* Top Heading */}
                    <div className="hrco-heading-top">
                        {/* <div className="hrco-badge">Onboarding</div> */}
                        <h1 className="hrco-main-heading">Ensure seamless onboarding</h1>
                    </div>

                    {/* Image Section */}
                    <div className="hrco-image-section">
                        <div className="image-wrapper">

                            <img
                                src="/images/onboard.png"
                                alt="Main Dashboard Preview"
                                className="image-main"
                            />

                            <img
                                src="/images/letter.png"
                                alt="Overlapping Dashboard"
                                className="image-overlap"
                            />
                        </div>
                    </div>

                    {/* Explore Button */}
                    <button className="hrco-explore-btn" onClick={handleAccessRecruit}>
                        Explore Onboarding
                    </button>

                </div>
            </div>
        </>
    );
}
